<template>
  <div class="main-nav">
    <ul class="main-menu">
      <li
        :class="{
          'main-menu-item register': true,
          active: $route.meta.isActive === 'register',
        }"
      >
        <router-link to="/register" class="bt">
          維持管理データ登録
        </router-link>
      </li>
      <li
        :class="{
          'main-menu-item register-count': true,
          active: $route.meta.isActive === 'registerCount',
        }"
      >
        <router-link to="/registerCount" class="bt"> 登録件数集計 </router-link>
      </li>
      <li
        :class="{
          'main-menu-item search': true,
          active: $route.meta.isActive === 'search',
        }"
      >
        <router-link to="/search" class="bt"> 維持管理データ一覧 </router-link>
      </li>
    </ul>

    <div class="main-nav">
      <h3 class="manual-title">様式・マニュアル</h3>
      <ul class="manual-menu" default-active="0" :router="false">
        <li
          class="manual-menu-item"
          :class="item.class"
          v-for="(item, index) in linkList"
          :key="index"
          :index="index"
        >
          <a
            :href="item.url"
            class="bt"
            target="_blank"
            rel="noopener noreferrer"
            :download="item.download"
            >{{ item.title }}
          </a>
        </li>
      </ul>
    </div>
    <!--/.manual-menu-->
  </div>
</template>

<script>
export default {
  name: "CommonMenu",
  data() {
    return {
      // 様式・マニュアル内に表示するリスト
      linkList: [],
    };
  },
  created() {
    // 様式・マニュアル内に表示するリストを
    this.linkList = [
      {
        id: 1,
        title: "入力用シート",
        url: "/assets/input-sheet.xlsm?download=1",
        class: "input-sheet",
        download: "維持管理データ入力用シート.xlsm",
      },
      {
        id: 2,
        title: "操作マニュアル",
        url: "/assets/operation-manual.pdf",
        class: "operation-manual",
        download: "操作マニュアル.pdf",
      },
      {
        id: 6,
        title: "外部APIマニュアル",
        url: "/assets/api-operation-manual.pdf",
        class: "api-operation-manual",
        download: "外部APIマニュアル.pdf",
      },
      {
        id: 7,
        title: "マスタ一覧",
        url: "/assets/master-data-list.xlsx?download=1",
        class: "master-data-list",
        download: "マスタ一覧.xlsx",
      },
      {
        id: 3,
        title: "地理院地図",
        url: "https://maps.gsi.go.jp/",
        class: "chiriin-chizu",
      },
      {
        id: 4,
        title: "枝番マップ",
        url: "https://www.jice.or.jp/pavement_db/pavement_db05",
        class: "branch-number-map",
      },
      {
        id: 5,
        title: "全国道路基盤地図等　データベース",
        url: "https://road-basemap.mlit.go.jp/JapanRoadMapWeb",
        class: "kibantizu-map-db",
      },
    ];
  },
};
</script>
